import { StandardEvents } from '@shopify/events';

(() => {
  function init(root = document) {
    root.querySelectorAll('[data-sv-night]:not([data-sv-ready])').forEach(section => {
      section.dataset.svReady = 'true';
      section.querySelectorAll('[data-mode]').forEach(button => button.addEventListener('click', () => {
        const night = button.dataset.mode === 'night';
        section.querySelector('[data-day]').hidden = night;
        section.querySelector('[data-night]').hidden = !night;
        section.querySelectorAll('[data-mode]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
    });
    root.querySelectorAll('[data-sv-product]:not([data-sv-ready])').forEach(section => {
      section.dataset.svReady = 'true';
      const image = section.querySelector('[data-sv-main-image]');
      const showImage = src => { if (image && src) { image.removeAttribute('srcset'); image.src = src; } };
      const zoom = section.querySelector('[data-sv-zoom]');
      const zoomImage = section.querySelector('[data-sv-zoom-image]');
      const zoomToggle = section.querySelector('[data-sv-zoom-toggle]');
      const zoomOpen = section.querySelector('[data-sv-zoom-open]');
      const openZoom = () => {
        if (!image || !zoom || !zoomImage) return;
        const source = new URL(image.currentSrc || image.src, location.href);
        source.searchParams.set('width', '2400');
        zoomImage.removeAttribute('srcset');
        zoomImage.src = source.href;
        zoomImage.alt = image.alt;
        zoomToggle.setAttribute('aria-pressed', 'false');
        zoom.showModal();
        zoom.scrollTo(0, 0);
      };
      zoomOpen?.addEventListener('click', openZoom);
      image?.addEventListener('click', openZoom);
      section.querySelector('[data-sv-zoom-close]')?.addEventListener('click', () => zoom.close());
      zoom?.addEventListener('close', () => zoomOpen?.focus({ preventScroll: true }));
      zoom?.addEventListener('click', event => {
        if (event.target === zoom) zoom.close();
      });
      zoomToggle?.addEventListener('click', event => {
        if (event.detail && zoomImage?.naturalWidth) {
          const rect = zoomImage.getBoundingClientRect();
          const scale = Math.min(rect.width / zoomImage.naturalWidth, rect.height / zoomImage.naturalHeight);
          const width = zoomImage.naturalWidth * scale;
          const height = zoomImage.naturalHeight * scale;
          const left = rect.left + (rect.width - width) / 2;
          const top = rect.top + (rect.height - height) / 2;
          if (event.clientX < left || event.clientX > left + width || event.clientY < top || event.clientY > top + height) {
            zoom.close();
            return;
          }
        }
        const enlarged = zoomToggle.getAttribute('aria-pressed') !== 'true';
        zoomToggle.setAttribute('aria-pressed', String(enlarged));
        if (!enlarged) zoom.scrollTo(0, 0);
      });
      const thumbnails = section.querySelectorAll('[data-sv-image]');
      thumbnails.forEach(button => {
        const selectImage = () => {
          showImage(button.dataset.svImage);
          thumbnails.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        };
        button.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') selectImage();
        });
        button.addEventListener('focus', selectImage);
        button.addEventListener('click', selectImage);
      });
      section.querySelector('[data-sv-variant]')?.addEventListener('change', event => {
        const option = event.target.selectedOptions[0];
        const available = option.dataset.available === 'true';
        section.querySelector('[data-sv-price]').textContent = option.dataset.price;
        const compare = section.querySelector('[data-sv-compare]');
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
        const button = section.querySelector('[data-sv-add]');
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableLabel : button.dataset.soldLabel;
        section.querySelector('[data-sv-stock]').hidden = available;
        showImage(option.dataset.image);
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
      });
    });
  }
  document.addEventListener(StandardEvents.cartLinesUpdate, event => {
    event.promise?.then(({ cart, detail }) => {
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (!Number.isFinite(count)) return;
      document.querySelectorAll('[data-sv-cart-label]').forEach(link => {
        link.querySelector('span').textContent = String(count);
        link.setAttribute('aria-label', `${link.dataset.svCartLabel} (${count})`);
      });
    }).catch(() => {});
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.sv-header details[open]').forEach(detail => { detail.open = false; detail.querySelector('summary').focus(); }); });
  document.addEventListener('click', event => document.querySelectorAll('.sv-header details[open]').forEach(detail => { if (!detail.contains(event.target)) detail.open = false; }));
})();
